import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Ripple } from "primereact/ripple";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toast } from 'primereact/toast';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { contactCreateAPI, createAreaForContact, deleteAreaForContact, employeeCompanyDataAPI, employeePersonalDataAPI, employeeRoleDataAPI, roleDataGetAPI, searchEmailService, updateAreaForContact } from "../../../Api/ContactApi";
import { checkEmail, checkFileImage, checkMobileNumber, checkPassword, checkPhoneNumber, checkRole, checkText } from "../../../Utils/Validator";
import { userProfile } from "../../../Api/UserData";
import { ProfileResponse } from "../../../Controllers/Types/UserDataResponce";
import { imageFileExtension } from "../../../Api/FileConstant";
import { goToTop } from "../../../Components/goToTop";
import { confirmDialog } from "primereact/confirmdialog";
import EmailSearchDialog from "../EmailSearchDialog";
import { getLoginUserRoleName, UserRoleName } from "../../../Utils/LoginUserRoleName";
import { EmployeeAreaList } from "../../../Controllers/Types/EmployeeInterface";
import { Dialog } from "primereact/dialog";
import TextInput from "../../../Components/TextInput";

// import { areaList } from "./SampleData";
import { useAppDispatch, useAppSelector } from "../../../Controllers/hooks";
import { getContactAreaList } from "../../../Controllers/Thunks/contactThunks";
import { set } from "date-fns";
import { PasswordException } from "pdfjs-dist/types/src/shared/util";
import { Password } from "primereact/password";
import { useSelector } from "react-redux";
import { RootState } from "../../../Controllers/Store";
import { hasPermission } from "../../../Controllers/Selectors/permissionsSelector";
import { Role } from "../../../Controllers/Types/UserRoleInterface";
import DataListModalInput from "../../../Components/DataListModal/DataListModalInput";
import RoleSelectionModal from "../../../Components/RoleSelectionModal";
import { Divider } from "primereact/divider";

interface EmployeeType {
    employee_type: string;
}

const employee_types: EmployeeType[] = [
    {
        employee_type: "Permanent employee"
    },
    {
        employee_type: "Temporary employee"
    },
    {
        employee_type: "Area manager"
    },
    {
        employee_type: "Building inspector"
    },
    {
        employee_type: "Plan check engineer"
    },
    {
        employee_type: "Employee"
    }
];

const AddEmployeeContact: React.FC = () => {
    const [page, setPage] = useState<number>(1);
    const toast = useRef<Toast>(null);
    const navigate = useNavigate();
    const location = useLocation();

    const [loading, setLoading] = useState<boolean>(false);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [showAddData, setShowAddData] = useState<boolean>(false);
    const [customCreateLoading, setCustomCreateLoading] = useState<boolean>(false);
    const [validEmployeeTypes, setValidEmployeeTypes] = useState<EmployeeType[]>([]);

    /* ********************** profile data ******************* */
    const [profileDataList, setProfileDataList] = useState<ProfileResponse>();

    const [loginUserRoleName, setLoginUserRoleName] = useState<UserRoleName | ''>('');

    /* For permission */
    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) => hasPermission(state, screen, permission));
    };

    const isPermissionEmployee = useCanEdit('Contact', 'Employee');
    const isPermissionProfessional = useCanEdit('Contact', 'Professional');
    const isPermissionClient = useCanEdit('Contact', 'Client');

    const dispatch = useAppDispatch();

    const header = <div className="font-bold mb-3">Password Strength</div>;
    const footer = (
        <React.Fragment>
            <Divider />
            <p className="mt-2">Suggestions</p>
            <ul className="pl-2 ml-2 mt-0 line-height-3">
                <li>At least one lowercase</li>
                <li>At least one uppercase</li>
                <li>At least one numeric</li>
                <li className="mb-0">Minimum 8 characters</li>
            </ul>
        </React.Fragment>
    );


    // Get logged in user role name
    useEffect(() => {
        const fetchUserRole = async () => {
            const roleName = await getLoginUserRoleName();
            setLoginUserRoleName(roleName);
        };

        fetchUserRole();
    }, []);


    // here the function call areaList
    // for fetching data fro api tigger with state object actions
    useEffect(() => {
        dispatch(getContactAreaList());
    }, []);

    // this is get data from state list and set projectlist
    const areaList = useAppSelector((state) => state.contactAreaList.areaList);

    useEffect(() => {
        if (employee_types && employee_types.length > 0) {
            let validTypes: EmployeeType[] = [];

            if (loginUserRoleName !== 'building inspector company') {
                validTypes = employee_types.filter(
                    (data) =>
                        data.employee_type === 'Permanent employee' ||
                        data.employee_type === 'Temporary employee'
                );
            } else {
                validTypes = employee_types.filter(
                    (data) =>
                        data.employee_type !== 'Permanent employee' &&
                        data.employee_type !== 'Temporary employee'
                );
            }

            setValidEmployeeTypes(validTypes);
        }
    }, [loginUserRoleName]);

    /*  */
    const [employeeType, setEmployeeType] = useState<EmployeeType>(employee_types[0]);

    const handleEmployeeTypeChange = (e: DropdownChangeEvent) => {
        confirmDialog({
            message: 'Are you sure you want to change the employee type? The fields you entered will be cleared.',
            header: 'Alert',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => {
                setEmployeeType(e.value);
                setSelectedArea(null);
            },
        });
    };

    useEffect(() => {
        if (location?.state && location?.state?.contactFor) {
            const contactAddFor = location?.state?.contactFor

            if (contactAddFor === 'Permanent employee') {
                setEmployeeType(employee_types?.filter(data => data?.employee_type === 'Permanent employee')?.[0]);
            } else if (contactAddFor === 'Temporary employee') {
                setEmployeeType(employee_types?.filter(data => data?.employee_type === 'Temporary employee')?.[0]);
            } else if (contactAddFor === 'Area manager') {
                setEmployeeType(employee_types?.filter(data => data?.employee_type === 'Area manager')?.[0]);
            } else if (contactAddFor === 'Building inspector') {
                setEmployeeType(employee_types?.filter(data => data?.employee_type === 'Building inspector')?.[0]);
            } else if (contactAddFor === 'Plan check engineer') {
                setEmployeeType(employee_types?.filter(data => data?.employee_type === 'Plan check engineer')?.[0]);
            } else if (contactAddFor === 'Employee') {
                setEmployeeType(employee_types?.filter(data => data?.employee_type === 'Employee')?.[0]);
            }
        } else {
            setEmployeeType(employee_types[0]);
        }
    }, [location?.state]);

    /* ******** contact id **************** */
    const [contactId, setContactId] = useState<number | undefined>(0);

    //Personal form variables
    const [profileImage, setProfileImage] = useState<string | null>(null);
    const [profileImageFile, setProfileImageFile] = useState<File | null>(null);
    const [firstName, setFirstName] = useState<string>('');
    const [lastName, setLastName] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [mobile, setMobile] = useState<string>('');
    const [landline, setLandline] = useState<string>('');
    const [address, setAddress] = useState<string>('');
    const [city, setCity] = useState<string>('');
    const [postCode, setPostCode] = useState<string>('');
    const [password, setPassword] = useState<string>('');

    /* Personal error message */
    const [errorProfileImageFile, setErrorProfileImageFile] = useState<string>('');
    const [errorFirstName, setErrorFirstName] = useState<string>('');
    const [errorLastName, setErrorLastName] = useState<string>('');
    const [errorEmail, setErrorEmail] = useState<string>('');
    const [errorMobile, setErrorMobile] = useState<string>('');
    const [errorLandline, setErrorLandline] = useState<string>('');
    const [errorAddress, setErrorAddress] = useState<string>('');
    const [errorCity, setErrorCity] = useState<string>('');
    const [errorPostCode, setErrorPostCode] = useState<string>('');
    const [errorArea, setErrorArea] = useState<string>('');
    const [errorPassword, setErrorPassword] = useState<string>('');

    //Company form variables
    const [companyPersonalEmail, setCompanyPersonalEmail] = useState<string>('');
    const [companyPersonalPhone, setCompanyPersonalPhone] = useState<string>('');
    const [companyName, setCompanyName] = useState<string>('');
    const [companyRegNo, setCompanyRegNo] = useState<string>('');
    const [companyEmail, setCompanyEmail] = useState<string>('');
    const [companyPhone, setCompanyPhone] = useState<string>('');
    const [companyAddress, setCompanyAddress] = useState<string>('');
    const [companyCity, setCompanyCity] = useState<string>('');
    const [companyPostCode, setCompanyPostCode] = useState<string>('');

    /* Company error massage */
    const [errorCompanyPersonalEmail, setErrorCompanyPersonalEmail] = useState<string>('');
    const [errorCompanyPersonalPhone, setErrorCompanyPersonalPhone] = useState<string>('');
    const [errorCompanyName, setErrorCompanyName] = useState<string>('');
    const [errorCompanyRegNo, setErrorCompanyRegNo] = useState<string>('');
    const [errorCompanyEmail, setErrorCompanyEmail] = useState<string>('');
    const [errorCompanyPhone, setErrorCompanyPhone] = useState<string>('');
    const [errorCompanyAddress, setErrorCompanyAddress] = useState<string>('');
    const [errorCompanyCity, setErrorCompanyCity] = useState<string>('');
    const [errorCompanyPostCode, setErrorCompanyPostCode] = useState<string>('');

    /* role form variables */
    const [roleName, setRoleName] = useState<string>('');

    const [errorRoleName, setErrorRoleName] = useState<string>('');

    //Role list 
    const [roleList, setRoleList] = useState<Role[]>([]);

    const [role, setRole] = useState<Role>({ id: 0, role_name: '', display_role_name: '', data_type: 'Default data' });
    const [displayRoleName, setDisplayRoleName] = useState<string>('');

    const [errorRoleId, setErrorRoleId] = useState<string>('');
    const [errorDisplayRoleName, setErrorDisplayRoleName] = useState<string>('');

    const [showSearchEmailModal, setShowSearchEmailModal] = useState<boolean>(false);

    //For image upload
    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (event: ProgressEvent<FileReader>) => {
                if (event.target && typeof event.target.result === 'string') {
                    setProfileImage(event.target.result);

                    const file = e.target.files?.[0];
                    setProfileImageFile(file!);
                }
            };
            reader.readAsDataURL(e.target.files[0]);
        }
    };

    // For clear image
    const clearImage = () => {
        setProfileImage(null);
        setProfileImageFile(null);
    };

    /* ************************************* profile data - start ************************************ */
    const profileData = async () => {
        if (localStorage.getItem('user_id') && localStorage.getItem('token')) {
            const data = await userProfile(localStorage.getItem('token') || '');
            if (data.status) {
                setProfileDataList(data);

                setCompanyName(data?.companyData?.company_name || '');
                setCompanyRegNo(data?.companyData?.company_regno || '');
                setCompanyEmail(data?.companyData?.company_email || '');
                setCompanyPhone(data?.companyData?.company_phone || '');
                setCompanyAddress(data?.companyData?.company_address || '');
                setCompanyCity(data?.companyData?.city || '');
                setCompanyPostCode(data?.companyData?.post_code || '');
            }
        }
    }
    /* ************************************* profile data - end ************************************ */

    /* **************************** role data get *************************** */
    const roleDataGet = async () => {
        const data = await roleDataGetAPI(localStorage.getItem('token') || '');
        if (data.status) {
            setRoleList(data.data || []);
        }
    }
    /* **************************** role data get *************************** */


    /* **************************** contact create *************************** */
    const contactCreate = async () => {
        let empType = "Employee";
        if (employeeType.employee_type === 'Permanent employee') {
            empType = "Employee";
        } else if (employeeType.employee_type === 'Area manager') {
            empType = "Area Manager";
        } else if (employeeType.employee_type === 'Building inspector') {
            empType = "Building Inspector";
        } else if (employeeType.employee_type === 'Plan check engineer') {
            empType = "Plan Check Engineer";
        } else if (employeeType.employee_type === 'Employee') {
            empType = "Employee";
        }


        const data = await contactCreateAPI("Employee", empType, localStorage.getItem('token') || '');
        if (data.status) {
            setContactId(data.contactId);
        }

        return data.contactId;
    }
    /* **************************** contact create *************************** */


    /* **************************** clear All error massage *************************** */
    const clearAllErrorMassage = () => {
        setErrorProfileImageFile('');
        setErrorFirstName('');
        setErrorLastName('');
        setErrorEmail('');
        setErrorMobile('');
        setErrorLandline('');
        setErrorAddress('');
        setErrorCity('');
        setErrorPostCode('');

        setErrorCompanyPersonalEmail('');
        setErrorCompanyPersonalPhone('');
        setErrorCompanyName('');
        setErrorCompanyRegNo('');
        setErrorCompanyEmail('');
        setErrorCompanyPhone('');
        setErrorCompanyAddress('');
        setErrorCompanyCity('');
        setErrorCompanyPostCode('');

        setErrorRoleName('');
        setErrorRoleId('');
        setErrorDisplayRoleName('');
    };
    /* **************************** clear All error massage *************************** */

    /* ************** API Error massage show ****************** */

    function showAPIErrorPersonalData(keyName: string, error: string): void {
        if (keyName === "email") {
            setErrorEmail(error);
        }
        if (keyName === "mobile") {
            setErrorMobile(error);
        }
        if (keyName === "landline") {
            setErrorLandline(error);
        }
        if (keyName === "profile_image") {
            setErrorProfileImageFile(error);
        }
    }

    function showAPIErrorComapanyData(keyName: string, error: string): void {
        if (keyName === "personal_email") {
            setErrorCompanyPersonalEmail(error);
        }
        if (keyName === "personal_phone") {
            setErrorCompanyPersonalPhone(error);
        }
        if (keyName === "regno") {
            setErrorCompanyRegNo(error);
        }
        if (keyName === "email") {
            setErrorCompanyEmail(error);
        }
        if (keyName === "phone") {
            setErrorCompanyPhone(error);
        }
    }
    /* ************** API Error massage show ****************** */


    /* **************************** Personal Details create - start *************************** */
    // For Save Personal Details
    const handleSavePersonalDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        clearAllErrorMassage();

        if (checkCredentials()) {
            setLoading(true);
            if (contactId === 0) {
                /* ***** contect create **** */
                const createdContactId = await contactCreate();

                saveEmployeePersonalData(Number(createdContactId));
            } else {
                saveEmployeePersonalData(Number(contactId));
            }
        }
    }

    const saveEmployeePersonalData = async (createdContactId: number) => {
        const data = await employeePersonalDataAPI(Number(createdContactId), firstName, lastName, email, mobile, landline, address, city, postCode, profileImageFile!, localStorage.getItem('token') || '', selectedArea?.id!, password);
        setLoading(false);
        if (!data.status) { // false
            if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorPersonalData(key, value[0])
                ))
            }
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Personal data created successfully.',
                    life: 3000
                });
            }
            setLoading(false);
            setPage(2);
            goToTop();
        }
    }

    function checkCredentials(): boolean {
        const isPasswordValid = checkPassword(password, true, setErrorPassword);
        const isEmailValid = checkEmail(email, true, setErrorEmail);
        const isFirstNameValid = checkText(firstName, true, setErrorFirstName);
        const isLastNameValid = checkText(lastName, true, setErrorLastName);
        const isMobileValid = checkMobileNumber(mobile, false, setErrorMobile);
        const isLandlineNumberValid = checkPhoneNumber(landline, false, setErrorLandline);
        const isAddressValid = checkText(address, true, setErrorAddress);
        const isCityValid = checkText(city, true, setErrorCity);
        const isPostCodeValid = checkText(postCode, true, setErrorPostCode);
        const isFileValid = checkFileImage(profileImageFile!, false, setErrorProfileImageFile);

        return isEmailValid && isFirstNameValid && isLastNameValid && isMobileValid && isLandlineNumberValid && isAddressValid && isCityValid && isPostCodeValid && isFileValid && isPasswordValid;
    }
    /* **************************** Personal Details create - end *************************** */


    /* **************************** Company data create - start *************************** */
    // For Save Company Details
    const handleSaveCompanyDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        clearAllErrorMassage();
        if (checkCredentialsCompanyData()) {
            setLoading(true);
            const data = await employeeCompanyDataAPI(Number(contactId), companyPersonalEmail, companyPersonalPhone, companyName, companyRegNo, companyEmail, companyPhone, companyAddress, companyCity, companyPostCode, "", localStorage.getItem('token') || '');
            setLoading(false);

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        showAPIErrorComapanyData(key, value[0])
                    ))
                } else {
                    if (toast.current) {
                        toast.current.show({
                            severity: 'error',
                            summary: 'Failed',
                            detail: 'Company data created failed.',
                            life: 3000
                        });
                    }
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Company data created successfully.',
                        life: 3000
                    });
                }

                setLoading(false);
                setPage(3);
                goToTop();
            }
        }
    }

    function checkCredentialsCompanyData(): boolean {
        const isCompanyPersonalEmailValid = checkEmail(companyPersonalEmail, false, setErrorCompanyPersonalEmail);
        const isCompanyPersonalPhoneValid = checkPhoneNumber(companyPersonalPhone, false, setErrorCompanyPersonalPhone);
        const isCompanyEmailValid = checkEmail(companyEmail, false, setErrorCompanyEmail);
        const isCompanyPhoneValid = checkPhoneNumber(companyPhone, false, setErrorCompanyPhone);

        return isCompanyPersonalEmailValid && isCompanyPersonalPhoneValid && isCompanyEmailValid && isCompanyPhoneValid;
    }
    /* **************************** Company data create - end *************************** */


    /* **************************** Role name create - start *************************** */


    const [showRoleSelectionModal, setShowRoleSelectionModal] = useState<boolean>(false);

    const handleShowRoleModal = () => {
        setShowRoleSelectionModal(true);
    }

    const handleCloseRoleModal = () => {
        setShowRoleSelectionModal(false);
    }





    function checkCredentialsRoleCreate(): boolean {
        const isRoleNameValid = checkText(roleName, true, setErrorRoleName);

        return isRoleNameValid;
    }
    /* **************************** Role name create - end *************************** */


    /* **************************** Role info create - start *************************** */
    // For Save Role Details
    const handleSaveRoleDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        clearAllErrorMassage();
        if (checkCredentialsRoleInfoCreate()) {

            setLoading(true);
            const data = await employeeRoleDataAPI(Number(contactId), Number(role.id), displayRoleName, localStorage.getItem('token') || '');
            setLoading(false);

            if (data.status) { // true
                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Role info created successfully.',
                        life: 3000
                    });
                }
                setLoading(false);
                setPage(1);

                setShowAlert(true);
                setTimeout(() => {
                    setShowAlert(false);
                    handleNavigateContact();
                }, 2000);
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'An error occurred while creating the role details.',
                        life: 3000
                    });
                }
                setLoading(false);
            }
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Failed',
                    detail: 'An error occurred while creating the role details.',
                    life: 3000
                });
            }
            setLoading(false);
        }
    }

    function checkCredentialsRoleInfoCreate(): boolean {
        const isRoleValid = checkRole(role, true, setErrorRoleId);
        const isDisplayRoleNameValid = checkText(displayRoleName, true, setErrorDisplayRoleName);

        return isRoleValid && isDisplayRoleNameValid;
    }

    /* **************************** Role info create - end *************************** */
    const [minHeight, setMinHeight] = useState<string>('0px');

    const calculateMinHeight = () => {
        const windowHeight = window.innerHeight;
        const distanceFromBottom = 200;
        const calculatedHeight = windowHeight - distanceFromBottom;
        setMinHeight(`${calculatedHeight}px`);
    };

    useEffect(() => {
        profileData();

        roleDataGet();
        calculateMinHeight();
        window.addEventListener('resize', calculateMinHeight);

        return () => {
            window.removeEventListener('resize', calculateMinHeight);
        };
    }, []);

    const goBack = () => {
        navigate(-1);
        goToTop();
    };

    const handleCloseAlert = () => {
        setShowAlert(false);
    };

    const toggleAddData = () => {
        setShowAddData(!showAddData);
    };

    const handleNavigateAddContact = (type: 'employee' | 'professional' | 'client') => {
        const currentPage = 'employee';

        if (currentPage !== type) {
            confirmDialog({
                message: `Are you sure you want to switch to ${type}? The fields you entered will be cleared.`,
                header: 'Alert',
                icon: 'bi bi-info-circle',
                defaultFocus: 'accept',
                acceptClassName: 'p-button-danger',
                accept: () => {
                    if (type === 'professional') {
                        navigate(`/contact/professional/add`);
                    } else if (type === 'client') {
                        navigate(`/contact/client/add`);
                    } else {
                        return;
                    }
                },
                dismissableMask: true,
                draggable: false,
                resizable: false,
            });
        } else {
            return;
        }
        goToTop();
    }

    /* ************************* for Temporary employee *********************** */
    const [tempContactId, setTempContactId] = useState<number | undefined>(0);

    //Form variables
    const [tempProfileImage, setTempProfileImage] = useState<string | null>(null);
    const [tempProfileImageFile, setTempProfileImageFile] = useState<File | null>(null);
    const [tempFirstName, setTempFirstName] = useState<string>('');
    const [tempLastName, setTempLastName] = useState<string>('');
    const [tempEmail, setTempEmail] = useState<string>('');
    const [tempMobile, setTempMobile] = useState<string>('');
    const [tempLandline, setTempLandline] = useState<string>('');
    const [tempAddress, setTempAddress] = useState<string>('');
    const [tempCity, setTempCity] = useState<string>('');
    const [tempPostCode, setTempPostCode] = useState<string>('');
    const [tempPassword, setTempPassword] = useState<string>('');

    /* error massage */
    const [errorTempProfileImage, setErrorTempProfileImage] = useState<string>('');
    const [errorTempFirstName, setErrorTempFirstName] = useState<string>('');
    const [errorTempLastName, setErrorTempLastName] = useState<string>('');
    const [errorTempEmail, setErrorTempEmail] = useState<string>('');
    const [errorTempMobile, setErrorTempMobile] = useState<string>('');
    const [errorTempLandline, setErrorTempLandline] = useState<string>('');
    const [errorTempAddress, setErrorTempAddress] = useState<string>('');
    const [errorTempCity, setErrorTempCity] = useState<string>('');
    const [errorTempPostCode, setErrorTempPostCode] = useState<string>('');
    const [errorTempPassword, setErrorTempPassword] = useState<string>('');

    const tempContactCreate = async () => {
        const data = await contactCreateAPI("Employee", "Temporary Employee", localStorage.getItem('token') || '');
        if (data.status) {
            setTempContactId(data.contactId);
        }

        return data.contactId;
    }

    function checkTempCredentials(): boolean {
        const isTempPassword = checkPassword(tempPassword, true, setErrorTempPassword);
        const isFirstNameValid = checkText(tempFirstName, true, setErrorTempFirstName);
        const isLastNameValid = checkText(tempLastName, false, setErrorTempLastName);
        const isEmailValid = checkEmail(tempEmail, false, setErrorTempEmail);
        const isMobileValid = checkMobileNumber(tempMobile, true, setErrorTempMobile);
        const isLandlineNumberValid = checkPhoneNumber(tempLandline, false, setErrorTempLandline);
        const isAddressValid = checkText(tempAddress, false, setErrorTempAddress);
        const isCityValid = checkText(tempCity, false, setErrorTempCity);
        const isPostCodeValid = checkText(tempPostCode, false, setErrorTempPostCode);
        const isFileValid = checkFileImage(tempProfileImageFile!, false, setErrorTempProfileImage);

        return isFirstNameValid && isLastNameValid && isEmailValid && isMobileValid && isLandlineNumberValid && isAddressValid && isCityValid && isPostCodeValid && isFileValid && isTempPassword;
    }

    const handleSaveTemporaryContact = async (e: React.FormEvent) => {
        e.preventDefault();

        handleClearTempContactErrors();

        if (checkTempCredentials()) {
            setLoading(true);

            if (tempContactId === 0) {
                /* ***** contect create **** */
                const createdContactId = await tempContactCreate();

                saveTemporaryContact(Number(createdContactId));
            } else {
                saveTemporaryContact(Number(tempContactId));
            }
        }
    }

    function showAPIErrorTempContactData(keyName: string, error: string): void {
        if (keyName === "email") {
            setErrorTempEmail(error);
        }
        if (keyName === "mobile") {
            setErrorTempMobile(error);
        }
        if (keyName === "landline") {
            setErrorTempLandline(error);
        }
        if (keyName === "profile_image") {
            setErrorTempProfileImage(error);
        }
    }

    const saveTemporaryContact = async (contactId: number) => {
        const data = await employeePersonalDataAPI(Number(contactId),
            tempFirstName,
            tempLastName,
            tempEmail,
            tempMobile,
            tempLandline,
            tempAddress,
            tempCity,
            tempPostCode,
            tempProfileImageFile!,
            localStorage.getItem('token') || '',
            null,
            tempPassword
        );

        setLoading(false);

        if (!data.status) {
            if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorTempContactData(key, value[0])
                ))
            }
        } else {
            handleClearTempContactFields();
            setLoading(false);
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
                handleNavigateContact();
            }, 2000);
        }
    }

    const handleClearTempContactFields = () => {
        handleClearTempProfileImage();

        setTempFirstName('');
        setTempLastName('');
        setTempEmail('');
        setTempMobile('');
        setTempLandline('');
        setTempAddress('');
        setTempCity('');
        setTempPostCode('');
    }

    const handleClearTempContactErrors = () => {
        setErrorTempProfileImage('');
        setErrorTempFirstName('');
        setErrorTempLastName('');
        setErrorTempEmail('');
        setErrorTempMobile('');
        setErrorTempLandline('');
        setErrorTempAddress('');
        setErrorTempCity('');
        setErrorTempPostCode('');
    }

    const handleTempContactImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (event: ProgressEvent<FileReader>) => {
                if (event.target && typeof event.target.result === 'string') {
                    setTempProfileImage(event.target.result);

                    const file = e.target.files?.[0];
                    setTempProfileImageFile(file!);
                }
            };
            reader.readAsDataURL(e.target.files[0]);
        }
    };

    const handleClearTempProfileImage = () => {
        setTempProfileImage('');
        setTempProfileImageFile(null);
    }

    const handleNavigateContact = () => {
        goToTop();

        const navigateFrom = location?.state?.navigateFrom ?? '';

        if (navigateFrom === 'site employees') {
            navigate(-1);
        } else {
            navigate(`/contact`);
        }
    }

    const onEmailConfirm = (email: string) => {
        setEmail(email);
        setShowSearchEmailModal(false);
    }

    /* ************************************************************************ */


    /* Clear validation messages */
    // For permanent employee
    // Personal
    useEffect(() => {
        checkEmail(email, false, setErrorEmail);
    }, [email]);

    useEffect(() => {
        checkText(firstName, false, setErrorFirstName);
    }, [firstName]);

    useEffect(() => {
        checkText(lastName, false, setErrorLastName);
    }, [lastName]);

    useEffect(() => {
        checkMobileNumber(mobile, false, setErrorMobile);
    }, [mobile]);

    useEffect(() => {
        checkPhoneNumber(landline, false, setErrorLandline);
    }, [landline]);

    useEffect(() => {
        checkText(address, false, setErrorAddress);
    }, [address]);

    useEffect(() => {
        checkText(city, false, setErrorCity);
    }, [city]);

    useEffect(() => {
        checkText(postCode, false, setErrorPostCode);
    }, [postCode]);

    useEffect(() => {
        checkFileImage(profileImageFile!, false, setErrorProfileImageFile);
    }, [profileImageFile]);
    // 

    // Company
    useEffect(() => {
        checkEmail(companyPersonalEmail, false, setErrorCompanyPersonalEmail);
    }, [companyPersonalEmail]);

    useEffect(() => {
        checkPhoneNumber(companyPersonalPhone, false, setErrorCompanyPersonalPhone);
    }, [companyPersonalPhone]);

    useEffect(() => {
        checkEmail(companyEmail, false, setErrorCompanyEmail);
    }, [companyEmail]);

    useEffect(() => {
        checkPhoneNumber(companyPhone, false, setErrorCompanyPhone);
    }, [companyPhone]);

    // Role
    useEffect(() => {
        checkRole(role, false, setErrorRoleId);
    }, [role]);

    useEffect(() => {
        checkText(displayRoleName, false, setErrorDisplayRoleName);
    }, [displayRoleName]);

    useEffect(() => {
        checkText(roleName, false, setErrorRoleName);
    }, [roleName]);
    // 

    // For temporary employee
    useEffect(() => {
        checkText(tempFirstName, false, setErrorTempFirstName);
    }, [tempFirstName]);

    useEffect(() => {
        checkText(tempLastName, false, setErrorTempLastName);
    }, [tempLastName]);

    useEffect(() => {
        checkEmail(tempEmail, false, setErrorTempEmail);
    }, [tempEmail]);

    useEffect(() => {
        checkMobileNumber(tempMobile, false, setErrorTempMobile);
    }, [tempMobile]);

    useEffect(() => {
        checkPhoneNumber(tempLandline, false, setErrorTempLandline);
    }, [tempLandline]);

    useEffect(() => {
        checkText(tempAddress, false, setErrorTempAddress);
    }, [tempAddress]);

    useEffect(() => {
        checkText(tempCity, false, setErrorTempCity);
    }, [tempCity]);

    useEffect(() => {
        checkText(tempPostCode, false, setErrorTempPostCode);
    }, [tempPostCode]);

    useEffect(() => {
        checkFileImage(tempProfileImageFile!, false, setErrorTempProfileImage);
    }, [tempProfileImageFile]);
    // 
    /*  */

    const [filteredAreaListData, setFilteredAreaListData] = useState<EmployeeAreaList[]>([]);
    const [selectedArea, setSelectedArea] = useState<EmployeeAreaList | null>(null);

    const [showAreaModal, setShowAreaModal] = useState<boolean>(false);
    const [areaSearchKey, setAreaSearchKey] = useState<string>("");
    const [customAreaName, setCustomAreaName] = useState<string>("");
    const [customAreaNameError, setCustomAreaNameError] = useState<string>("");

    const [selectedAreaId, setSelectedAreaId] = useState<number | null>(null);
    const [showAreaEditModal, setShowAreaEditModal] = useState<boolean>(false);
    const [areaName, setAreaName] = useState<string>('');
    const [areaNameError, setAreaNameError] = useState<string>('');


    useEffect(() => {
        if (areaList && areaList?.length > 0) {
            const filteredData = areaList.filter((area) =>
                area?.area_name!.toLowerCase().includes(areaSearchKey.toLowerCase())
            );

            setFilteredAreaListData(filteredData);
        } else {
            setFilteredAreaListData([]);
        }
    }, [areaList, areaSearchKey]);



    const handleCloseAreaModal = () => {
        setShowAreaModal(false);
        setAreaSearchKey("");

        handleClearCustomAreaFields();
    };

    const handleClearCustomAreaFields = () => {
        setCustomAreaName('');
        setCustomAreaNameError('');
    }

    const handleAddArea = () => {
        setShowAreaModal(true);
    };

    const handleSelectArea = (area: EmployeeAreaList) => {
        setSelectedArea(area);

        setTimeout(() => {
            handleCloseAreaModal();
        }, 200);
    }



    // for database error
    function showAPIErrorAreaAdd(keyName: string, error: string): void {
        if (keyName === "area_name") {
            setCustomAreaNameError(error);
        }
    }


    // for database error
    function showAPIErrorAreaUpdate(keyName: string, error: string): void {
        if (keyName === "area_name") {
            setAreaNameError(error);
        }
    }

    useEffect(() => {
        setCustomAreaNameError('');
    }, [customAreaName]);

    useEffect(() => {
        setAreaNameError('');
    }, [areaName]);


    const handleCreateArea = async (e: React.FormEvent) => {
        e.preventDefault();

        setCustomCreateLoading(true);
        const data = await createAreaForContact(
            customAreaName
        );
        if (data.statusCode === 200) {
            // call dispach event
            dispatch(getContactAreaList());
            setCustomCreateLoading(false);
            handleClearCustomAreaFields();
            if (toast.current) {
                toast.current.show({
                    severity: "success",
                    summary: "Success",
                    detail: "Area created successfully.",
                    life: 3000,
                });
            }
        } else if (data.statusCode === 422) {
            setLoading(false);

            Object.entries(data.errors ?? []).map(([key, value], index) => (
                showAPIErrorAreaAdd(key, value[0])
            ));
        } else {
            setCustomCreateLoading(false);
            if (toast.current) {
                toast.current.show({
                    severity: "error",
                    summary: "Failed",
                    detail: "There was an error creating the area.",
                    life: 3000,
                });
            }
        }
    };

    const handleCloseAreaEditModal = () => {
        setShowAreaEditModal(false);
        setAreaName('');
        setAreaNameError('');
        setSelectedAreaId(null);
    }

    const handleEditArea = (area: EmployeeAreaList) => {
        setShowAreaEditModal(true);
        setAreaName(area?.area_name);
        setSelectedAreaId(area?.id);
    };

    const handleUpdateArea = async (e: React.FormEvent) => {
        e.preventDefault();

        setLoading(true);
        const data = await updateAreaForContact(
            selectedAreaId!,
            areaName
        );
        if (data.statusCode === 200) {
            // call dispach event
            dispatch(getContactAreaList());
            setLoading(false);
            handleCloseAreaEditModal();
            if (toast.current) {
                toast.current.show({
                    severity: "success",
                    summary: "Success",
                    detail: "Area updated successfully.",
                    life: 3000,
                });
            }
        } else if (data.statusCode === 422) {
            setLoading(false);

            Object.entries(data.errors ?? []).map(([key, value], index) => (
                showAPIErrorAreaUpdate(key, value[0])
            ));
        } else {
            setLoading(false);
            if (toast.current) {
                toast.current.show({
                    severity: "error",
                    summary: "Failed",
                    detail: "There was an error updating the area.",
                    life: 3000,
                });
            }
        }
    };

    const handleDeleteArea = (areaId: number) => {
        confirmDialog({
            message: 'Are you sure you want to delete this area',
            header: 'Confirm the deletion',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => deleteArea(areaId),
            dismissableMask: true,
            resizable: false,
            draggable: false,
        });
    }

    const deleteArea = async (areaId: number) => {
        try {
            const data = await deleteAreaForContact(areaId);
            if (data.statusCode === 200) {
                // call dispach event
                dispatch(getContactAreaList());
                handleCloseAreaEditModal();
                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Area deleted successfully.",
                        life: 3000,
                    });
                }
            }

        } catch (error) {
            if (toast.current) {
                toast.current.show({
                    severity: "error",
                    summary: "Failed",
                    detail: "There was an error deleting the area.",
                    life: 3000,
                });
            }
        }
    }

    const areaEditModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Edit area
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={() => handleDeleteArea(selectedAreaId!)}>
                <i className="bi bi-trash3"></i>
                <Ripple />
            </button>
        </div>
    );

    const areaEditModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseAreaEditModal}
            />

            <Button
                label={`${loading ? "Processing" : "Update"}`}
                onClick={handleUpdateArea}
                loading={loading}
                className="custom_btn primary"
            />
        </div>
    );

    return (
        <React.Fragment>

            <Toast ref={toast} />

            <div className="main_content layout_padding show_side_bar">
                <div className="main_head_area">
                    <h4 className="main_heading">Create Contact</h4>

                    <button className="back_btn p-ripple" onClick={goBack}>
                        <i className="bi bi-arrow-left me-2"></i>
                        Back
                        <Ripple />
                    </button>
                </div>

                <div className="page_content">
                    <div className="page_header_area">
                        <div className="contact_tabs">
                            {(isPermissionEmployee) && (
                                <div className="contact_tab_item">
                                    <button
                                        type="button"
                                        className="contact_tab_btn active p-ripple"
                                        onClick={() => handleNavigateAddContact('employee')}
                                    >
                                        Employee
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>
                            )}

                            {(isPermissionProfessional) && (
                                <div className="contact_tab_item">
                                    <button
                                        type="button"
                                        className="contact_tab_btn p-ripple"
                                        onClick={() => handleNavigateAddContact('professional')}
                                    >
                                        Professional
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>
                            )}

                            {(isPermissionClient) && (
                                <div className="contact_tab_item">
                                    <button
                                        type="button"
                                        className="contact_tab_btn p-ripple"
                                        onClick={() => handleNavigateAddContact('client')}
                                    >
                                        Client
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>
                            )}
                        </div>

                        <div className="select_option_area">
                            <Dropdown
                                value={employeeType}
                                id="employeeType"
                                onChange={handleEmployeeTypeChange}
                                options={validEmployeeTypes}
                                optionLabel="employee_type"
                                placeholder="Employee type"
                                className="form_dropdown w-100"
                            />
                        </div>
                    </div>

                    {employeeType.employee_type !== 'Temporary employee' ? (
                        <div className="page_body_area" style={{ minHeight }}>
                            <div className="row">
                                <div className="col-12">
                                    <div className="add_data_track_area">
                                        <div className={`add_data_track_point has_label ${page === 1 || page === 2 || page === 3 ? 'active' : ''}`} data-label="Personal">
                                            <span>1</span>
                                        </div>

                                        <div className={`add_data_track_line ${page === 2 || page === 3 ? 'active' : ''}`}></div>

                                        <div className={`add_data_track_point has_label ${page === 2 || page === 3 ? 'active' : ''}`} data-label="Company">
                                            <span>2</span>
                                        </div>

                                        <div className={`add_data_track_line ${page === 3 ? 'active' : ''}`}></div>

                                        <div className={`add_data_track_point has_label ${page === 3 ? 'active' : ''}`} data-label="Role">
                                            <span>3</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {page === 1 ? (
                                // Personal Form
                                <div className="row mt-5">
                                    <div className="col-12 col-xl-3 mx-auto page_divider">
                                        <div className="form_left_area">
                                            <div className="form_img_upload_area">
                                                <div className="form_img_upload">
                                                    <input
                                                        type="file"
                                                        accept={imageFileExtension}
                                                        className="form_img_upload_input"
                                                        id="profileImage"
                                                        onChange={handleImageChange}
                                                    />
                                                    <label
                                                        htmlFor="profileImage"
                                                        className={`form_img_upload_label ${profileImage ? 'uploaded' : ''}`}
                                                        style={{ backgroundImage: profileImage ? `url(${profileImage})` : `` }}
                                                    >
                                                        {!profileImage && (
                                                            <div className="upload_icon">
                                                                <i className="bi bi-camera-fill"></i>
                                                            </div>
                                                        )}
                                                    </label>
                                                    {profileImage ? (
                                                        <button className="upload_clear_button mt-2" onClick={clearImage}>Clear</button>
                                                    ) : (
                                                        <label htmlFor="profileImage" className="add_image_label mt-2">Add image</label>
                                                    )}
                                                </div>
                                            </div>
                                            {errorProfileImageFile &&
                                                <small className="form_error_msg text-center mt-2">{errorProfileImageFile}</small>
                                            }
                                        </div>
                                    </div>

                                    <div className="col-12 col-xl-9 mx-auto">
                                        <div className="form_right_area">
                                            <div className="page_data_form_area">
                                                <div className="row">
                                                    {/* First name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="firstName" className="custom_form_label is_required">First name</label>
                                                            <InputText
                                                                id="firstName"
                                                                value={firstName}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFirstName(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="First name"
                                                            />

                                                            {errorFirstName &&
                                                                <small className="form_error_msg">{errorFirstName}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Last name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="lastName" className="custom_form_label is_required">Last name</label>
                                                            <InputText
                                                                id="lastName"
                                                                value={lastName}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLastName(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Last name"
                                                            />

                                                            {errorLastName &&
                                                                <small className="form_error_msg">{errorLastName}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Area */}
                                                    {(employeeType?.employee_type === 'Area manager' || employeeType?.employee_type === 'Building inspector') && (
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label
                                                                    htmlFor="area"
                                                                    className="custom_form_label is_required"
                                                                >
                                                                    Area
                                                                </label>
                                                                <div className="input_with_button_area">
                                                                    <InputText
                                                                        id="area"
                                                                        value={selectedArea ? selectedArea?.area_name : ''}
                                                                        className="custom_form_input has_add_value"
                                                                        placeholder="Click to select the area."
                                                                        readOnly={true}
                                                                        autoComplete="off"
                                                                        onClick={handleAddArea}
                                                                    />
                                                                    <button
                                                                        className="add_value_btn p-ripple"
                                                                        onClick={handleAddArea}
                                                                    >
                                                                        {selectedArea === null ? (
                                                                            <React.Fragment>
                                                                                <i className="bi bi-plus-lg"></i>
                                                                                <span>Add</span>
                                                                            </React.Fragment>
                                                                        ) : (
                                                                            <React.Fragment>
                                                                                <i className="bi bi-pencil-square"></i>
                                                                                <span>Change</span>
                                                                            </React.Fragment>
                                                                        )}
                                                                        <Ripple />
                                                                    </button>
                                                                </div>

                                                                {errorArea && (
                                                                    <small className="form_error_msg">{errorArea}</small>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* Email */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="email" className="custom_form_label is_required">Email</label>

                                                            <div className="input_search_group">
                                                                <InputText
                                                                    id="email"
                                                                    value={email}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Email"
                                                                    disabled
                                                                />

                                                                {!email ? (
                                                                    <button
                                                                        className="input_grp_btn primary pos_abs p-ripple"
                                                                        onClick={() => setShowSearchEmailModal(true)}>
                                                                        <i className="bi bi-search"></i>
                                                                        <Ripple />
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        className="input_grp_btn danger pos_abs p-ripple"
                                                                        onClick={() => setEmail('')}>
                                                                        <i className="bi bi-x-lg"></i>
                                                                        <Ripple />
                                                                    </button>
                                                                )}
                                                            </div>

                                                            {errorEmail &&
                                                                <small className="form_error_msg">{errorEmail}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label
                                                                htmlFor="password"
                                                                className="custom_form_label is_required"
                                                            >
                                                                Password
                                                            </label>
                                                            <Password
                                                                key={`password`}
                                                                value={password}
                                                                inputId="password"
                                                                onChange={(
                                                                    e: React.ChangeEvent<HTMLInputElement>
                                                                ) => setPassword(e.target.value)}
                                                                toggleMask
                                                                header={header}
                                                                footer={footer}
                                                                tabIndex={1}
                                                                className="custom_form_input w-100"
                                                                placeholder="Enter your current password"
                                                            />
                                                            {errorPassword && (
                                                                <small className="form_error_msg">
                                                                    {errorPassword}
                                                                </small>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Mobile */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="mobile" className="custom_form_label">Mobile</label>
                                                            <InputText
                                                                id="mobile"
                                                                value={mobile}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setMobile(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Mobile"
                                                            />

                                                            {errorMobile &&
                                                                <small className="form_error_msg">{errorMobile}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Landline */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="landline" className="custom_form_label">Landline</label>
                                                            <InputText
                                                                id="landline"
                                                                value={landline}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLandline(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Landline"
                                                            />

                                                            {errorLandline &&
                                                                <small className="form_error_msg">{errorLandline}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Address */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="address" className="custom_form_label is_required">Address</label>
                                                            <InputText
                                                                id="address"
                                                                value={address}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAddress(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Address"
                                                            />

                                                            {errorAddress &&
                                                                <small className="form_error_msg">{errorAddress}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* City */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="city" className="custom_form_label is_required">City</label>
                                                            <InputText
                                                                id="city"
                                                                value={city}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCity(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="City"
                                                            />

                                                            {errorCity &&
                                                                <small className="form_error_msg">{errorCity}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Post code */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="postCode" className="custom_form_label is_required">Post code</label>
                                                            <InputText
                                                                id="postCode"
                                                                value={postCode}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPostCode(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Post code"
                                                            />

                                                            {errorPostCode &&
                                                                <small className="form_error_msg">{errorPostCode}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="form_btn_area justify-content-end">
                                                            <Button
                                                                label={`${loading ? 'Processing' : 'Save & Next'}`}
                                                                className="form_btn"
                                                                loading={loading}
                                                                onClick={handleSavePersonalDetails}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : page === 2 ? (
                                // Company Form
                                <div className="row mt-5">
                                    <div className="col-12 col-xl-4 mx-auto page_divider">
                                        <div className="form_left_area">
                                            <div className="row mt-4 w-100">
                                                {/* Company personal email */}
                                                <div className="col-12 col-sm-6 col-xl-12">
                                                    <div className="page_form_group">
                                                        <label htmlFor="companyPersonalEmail" className="custom_form_label">Company personal email</label>
                                                        <InputText
                                                            id="companyPersonalEmail"
                                                            value={companyPersonalEmail}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyPersonalEmail(e.target.value)}
                                                            className="custom_form_input"
                                                            placeholder="Company personal email"
                                                        />

                                                        {errorCompanyPersonalEmail &&
                                                            <small className="form_error_msg">{errorCompanyPersonalEmail}</small>
                                                        }
                                                    </div>
                                                </div>

                                                {/* Company personal phone */}
                                                <div className="col-12 col-sm-6 col-xl-12">
                                                    <div className="page_form_group">
                                                        <label htmlFor="companyPersonalPhone" className="custom_form_label">Company personal phone</label>
                                                        <InputText
                                                            id="companyPersonalPhone"
                                                            value={companyPersonalPhone}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyPersonalPhone(e.target.value)}
                                                            className="custom_form_input"
                                                            placeholder="Company personal phone"
                                                        />

                                                        {errorCompanyPersonalPhone &&
                                                            <small className="form_error_msg">{errorCompanyPersonalPhone}</small>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-xl-8 mx-auto">
                                        <div className="form_right_area">
                                            <div className="page_data_form_area">
                                                <div className="row">
                                                    {/* Company name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="companyName" className="custom_form_label">Company name</label>
                                                            <InputText
                                                                id="companyName"
                                                                value={companyName}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyName(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Company name"
                                                            />

                                                            {errorCompanyName &&
                                                                <small className="form_error_msg">{errorCompanyName}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Reg. no. */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="companyRegNo" className="custom_form_label">Reg. no.</label>
                                                            <InputText
                                                                id="companyRegNo"
                                                                value={companyRegNo}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyRegNo(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Reg. no."
                                                            />

                                                            {errorCompanyRegNo &&
                                                                <small className="form_error_msg">{errorCompanyRegNo}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Company email */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="companyEmail" className="custom_form_label">Company email</label>
                                                            <InputText
                                                                id="companyEmail"
                                                                value={companyEmail}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyEmail(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Company email"
                                                            />

                                                            {errorCompanyEmail &&
                                                                <small className="form_error_msg">{errorCompanyEmail}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Company phone */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="companyPhone" className="custom_form_label">Company phone</label>
                                                            <InputText
                                                                id="companyPhone"
                                                                value={companyPhone}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyPhone(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Company phone"
                                                            />

                                                            {errorCompanyPhone &&
                                                                <small className="form_error_msg">{errorCompanyPhone}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Address */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="companyAddress" className="custom_form_label">Address</label>
                                                            <InputText
                                                                id="companyAddress"
                                                                value={companyAddress}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyAddress(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Address"
                                                            />

                                                            {errorCompanyAddress &&
                                                                <small className="form_error_msg">{errorCompanyAddress}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* City */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="companyCity" className="custom_form_label">City</label>
                                                            <InputText
                                                                id="companyCity"
                                                                value={companyCity}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyCity(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="City"
                                                            />

                                                            {errorCompanyCity &&
                                                                <small className="form_error_msg">{errorCompanyCity}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Post code */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="companyPostCode" className="custom_form_label">Post code</label>
                                                            <InputText
                                                                id="companyPostCode"
                                                                value={companyPostCode}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyPostCode(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Post code"
                                                            />

                                                            {errorCompanyPostCode &&
                                                                <small className="form_error_msg">{errorCompanyPostCode}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="form_btn_area justify-content-end">
                                                            <Button
                                                                label={`${loading ? 'Processing' : 'Save & Next'}`}
                                                                className="form_btn"
                                                                loading={loading}
                                                                onClick={handleSaveCompanyDetails}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : page === 3 ? (
                                //Role Form
                                <div className="row mt-5">
                                    <div className="col-12 col-xl-8 mx-auto h-100">
                                        <div className="page_data_form_area">
                                            <div className="form_right_area">
                                                <div className="row">
                                                    {/* Role name */}

                                                    {/* Role name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <DataListModalInput
                                                            key={`role`}
                                                            inputId="role"
                                                            label="Role"
                                                            value={role}
                                                            displayKey="role_name"
                                                            onAdd={handleShowRoleModal}
                                                            required={true}
                                                            placeHolder="Click to select the role"
                                                            error={errorRoleId}
                                                        />
                                                    </div>



                                                    {/* Display role name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="displayRoleName" className="custom_form_label is_required">Display role name</label>
                                                            <InputText
                                                                id="displayRoleName"
                                                                value={displayRoleName}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDisplayRoleName(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Display role name"
                                                            />
                                                            {errorDisplayRoleName &&
                                                                <small className="form_error_msg">{errorDisplayRoleName}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="form_btn_area justify-content-end">
                                                            <Button
                                                                label={`${loading ? 'Processing' : 'Save'}`}
                                                                className="form_btn"
                                                                loading={loading}
                                                                onClick={handleSaveRoleDetails}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null
                            }
                        </div>
                    ) : employeeType.employee_type === 'Temporary employee' ? (
                        <div className="page_body_area" style={{ minHeight }}>
                            <div className="row">
                                <div className="col-12 col-xl-3 mx-auto page_divider">
                                    <div className="form_left_area">
                                        <div className="form_img_upload_area">
                                            <div className="form_img_upload">
                                                <input
                                                    type="file"
                                                    accept={imageFileExtension}
                                                    className="form_img_upload_input"
                                                    id="tempProfileImage"
                                                    onChange={handleTempContactImageChange}
                                                />
                                                <label
                                                    htmlFor="tempProfileImage"
                                                    className={`form_img_upload_label ${tempProfileImage ? 'uploaded' : ''}`}
                                                    style={{ backgroundImage: tempProfileImage ? `url(${tempProfileImage})` : `` }}
                                                >
                                                    {!tempProfileImage && (
                                                        <div className="upload_icon">
                                                            <i className="bi bi-camera-fill"></i>
                                                        </div>
                                                    )}
                                                </label>
                                                {tempProfileImage ? (
                                                    <button className="upload_clear_button mt-2" onClick={handleClearTempProfileImage}>Clear</button>
                                                ) : (
                                                    <label htmlFor="profileImage" className="add_image_label mt-2">Add image</label>
                                                )}
                                            </div>
                                        </div>
                                        {errorTempProfileImage &&
                                            <small className="form_error_msg text-center mt-2">{errorTempProfileImage}</small>
                                        }
                                    </div>
                                </div>

                                <div className="col-12 col-xl-9 mx-auto">
                                    <div className="form_right_area">
                                        <div className="page_data_form_area">
                                            <div className="row">
                                                {/* First name */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <div className="page_form_group">
                                                        <label htmlFor="tempFirstName" className="custom_form_label is_required">First name</label>
                                                        <InputText
                                                            id="tempFirstName"
                                                            value={tempFirstName}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTempFirstName(e.target.value)}
                                                            className="custom_form_input"
                                                            placeholder="First name"
                                                        />

                                                        {errorTempFirstName &&
                                                            <small className="form_error_msg">{errorTempFirstName}</small>
                                                        }
                                                    </div>
                                                </div>

                                                {/* Last name */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <div className="page_form_group">
                                                        <label htmlFor="tempLastName" className="custom_form_label">Last name</label>
                                                        <InputText
                                                            id="tempLastName"
                                                            value={tempLastName}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTempLastName(e.target.value)}
                                                            className="custom_form_input"
                                                            placeholder="Last name"
                                                        />

                                                        {errorTempLastName &&
                                                            <small className="form_error_msg">{errorTempLastName}</small>
                                                        }
                                                    </div>
                                                </div>

                                                {/* Email */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <div className="page_form_group">
                                                        <label htmlFor="tempEmail" className="custom_form_label">Email</label>
                                                        <InputText
                                                            id="tempEmail"
                                                            value={tempEmail}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTempEmail(e.target.value)}
                                                            className="custom_form_input"
                                                            placeholder="Email"
                                                        />

                                                        {errorTempEmail &&
                                                            <small className="form_error_msg">{errorTempEmail}</small>
                                                        }
                                                    </div>
                                                </div>
                                                {/* Password */}

                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <div className="page_form_group">
                                                        <label
                                                            htmlFor="password"
                                                            className="custom_form_label is_required"
                                                        >
                                                            Password
                                                        </label>
                                                        <Password
                                                            key={`password`}
                                                            value={tempPassword}
                                                            inputId="password"
                                                            onChange={(
                                                                e: React.ChangeEvent<HTMLInputElement>
                                                            ) => setTempPassword(e.target.value)}
                                                            feedback={false}
                                                            toggleMask
                                                            tabIndex={1}
                                                            className="custom_form_input w-100"
                                                            placeholder="Enter your current password"
                                                        />
                                                        {errorTempPassword && (
                                                            <small className="form_error_msg">
                                                                {errorTempPassword}
                                                            </small>
                                                        )}
                                                    </div>
                                                </div>


                                                {/* Mobile */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <div className="page_form_group">
                                                        <label htmlFor="tempMobile" className="custom_form_label is_required">Mobile</label>
                                                        <InputText
                                                            id="tempMobile"
                                                            value={tempMobile}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTempMobile(e.target.value)}
                                                            className="custom_form_input"
                                                            placeholder="Mobile"
                                                        />

                                                        {errorTempMobile &&
                                                            <small className="form_error_msg">{errorTempMobile}</small>
                                                        }
                                                    </div>
                                                </div>

                                                {/* Landline */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <div className="page_form_group">
                                                        <label htmlFor="tempLandline" className="custom_form_label">Landline</label>
                                                        <InputText
                                                            id="tempLandline"
                                                            value={tempLandline}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTempLandline(e.target.value)}
                                                            className="custom_form_input"
                                                            placeholder="Landline"
                                                        />

                                                        {errorTempLandline &&
                                                            <small className="form_error_msg">{errorTempLandline}</small>
                                                        }
                                                    </div>
                                                </div>

                                                {/* Address */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <div className="page_form_group">
                                                        <label htmlFor="tempAddress" className="custom_form_label">Address</label>
                                                        <InputText
                                                            id="tempAddress"
                                                            value={tempAddress}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTempAddress(e.target.value)}
                                                            className="custom_form_input"
                                                            placeholder="Address"
                                                        />

                                                        {errorTempAddress &&
                                                            <small className="form_error_msg">{errorTempAddress}</small>
                                                        }
                                                    </div>
                                                </div>

                                                {/* City */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <div className="page_form_group">
                                                        <label htmlFor="tempCity" className="custom_form_label">City</label>
                                                        <InputText
                                                            id="tempCity"
                                                            value={tempCity}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTempCity(e.target.value)}
                                                            className="custom_form_input"
                                                            placeholder="City"
                                                        />

                                                        {errorTempCity &&
                                                            <small className="form_error_msg">{errorTempCity}</small>
                                                        }
                                                    </div>
                                                </div>

                                                {/* Post code */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <div className="page_form_group">
                                                        <label htmlFor="tempPostCode" className="custom_form_label">Post code</label>
                                                        <InputText
                                                            id="tempPostCode"
                                                            value={tempPostCode}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTempPostCode(e.target.value)}
                                                            className="custom_form_input"
                                                            placeholder="Post code"
                                                        />

                                                        {errorTempPostCode &&
                                                            <small className="form_error_msg">{errorTempPostCode}</small>
                                                        }
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="form_btn_area justify-content-end">
                                                        <Button
                                                            label={`${loading ? 'Processing' : 'Save'}`}
                                                            className="form_btn"
                                                            loading={loading}
                                                            onClick={handleSaveTemporaryContact}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null
                    }
                </div>
            </div >

            {/* Show success message */}
            <div className={`message_backdrop ${showAlert ? 'show' : ''}`} onClick={handleCloseAlert}>
                <div className={`message_box ${showAlert ? 'show' : ''}`} onClick={e => e.stopPropagation()}>
                    <div className="message_box_content">
                        <i className="bi bi-check-circle-fill message_box_icon"></i>
                        <h6 className="message_box_message">
                            Employee details added successfully.
                        </h6>
                    </div>
                </div>
            </div>
            {/*  */}

            <EmailSearchDialog
                visible={showSearchEmailModal}
                contactSubtype="Employee"
                onHide={() => setShowSearchEmailModal(false)}
                onEmailConfirm={(email) => onEmailConfirm(email)}
            />

            {/* Area list modal */}
            <Dialog
                visible={showAreaModal}
                headerClassName="d-none"
                dismissableMask
                className="custom_modal_dialog modal_dialog_sm data_select_modal"
                contentClassName="data_select_modal_content"
                onHide={handleCloseAreaModal}
            >
                <div className="custom_modal_body data_select_modal_area">
                    <div className="data_select_modal_header">
                        <div className="data_search_input_area">
                            <InputText
                                key={"areaSearchKey"}
                                id="areaSearchKey"
                                value={areaSearchKey}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                    setAreaSearchKey(e.target.value)
                                }
                                className="custom_form_input data_search_input"
                                placeholder="Search area by name"
                                autoComplete="off"
                                autoFocus
                                type={"search"}
                            />
                            {areaSearchKey === "" ? (
                                <i className="bi bi-search"></i>
                            ) : (
                                <i
                                    className="bi bi-x-lg data_search_input_clear"
                                    onClick={() => setAreaSearchKey("")}
                                ></i>
                            )}
                        </div>

                        <button
                            type="button"
                            className="data_select_modal_close p-ripple"
                            onClick={handleCloseAreaModal}
                        >
                            <i className="bi bi-x"></i>
                            <Ripple />
                        </button>
                    </div>

                    <div className="data_select_modal_body has_custom_input">
                        {filteredAreaListData && filteredAreaListData?.length > 0 ? (
                            <div className="data_select_option_area">
                                {filteredAreaListData?.map((area) => (
                                    <div
                                        key={area?.id}
                                        className={`data_select_option has_edit p-ripple ${area?.id === selectedArea?.id ? "selected" : ""}`}
                                        onClick={() => handleSelectArea(area)}
                                    >
                                        {area?.area_name}

                                        <button className="is_btn data_select_option_edit_btn p-ripple"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleEditArea(area);
                                            }}>
                                            <i className="bi bi-pencil-square"></i>
                                        </button>

                                        <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }}
                                        />
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="no_records_found">
                                <i className="bi bi-exclamation-circle me-1"></i>
                                No data found.
                            </div>
                        )}
                    </div>

                    <div className="page_form_group data_select_modal_footer mb-0">
                        <div className="input_with_button_area">
                            <InputText
                                id="customAreaName"
                                value={customAreaName}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                    setCustomAreaName(e.target.value)
                                }
                                className="custom_form_input has_add_value custom_data_input"
                                placeholder="Enter area name"
                                autoComplete="off"
                            />
                            <button
                                className="add_value_btn fill p-ripple"
                                onClick={handleCreateArea}
                                disabled={customCreateLoading || customAreaName === ""}
                            >
                                {customCreateLoading ? (
                                    <span>Processing</span>
                                ) : (
                                    <React.Fragment>
                                        <i className="bi bi-plus-lg"></i>
                                        <span>Add</span>
                                    </React.Fragment>
                                )}
                                <Ripple />
                            </button>
                        </div>
                        {customAreaNameError && (
                            <small className="form_error_msg">{customAreaNameError}</small>
                        )}
                    </div>
                </div>
            </Dialog>
            {/*  */}


            {/* Area edit modal */}
            <Dialog
                visible={showAreaEditModal}
                headerClassName="custom_modal_header"
                header={areaEditModalHeader}
                footer={areaEditModalFooter}
                dismissableMask
                className="custom_modal_dialog modal_dialog_xsm"
                onHide={handleCloseAreaEditModal}
            >
                <div className="custom_modal_body">
                    <div className="p-1 w-100">
                        <div className="row">
                            <div className="col-12">
                                <TextInput
                                    key={`areaName`}
                                    id="areaName"
                                    label="Area"
                                    labelHtmlFor="areaName"
                                    required={true}
                                    value={areaName}
                                    inputType="text"
                                    placeholder="Area"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAreaName(e.target.value)}
                                    error={areaNameError}
                                    formGroupClassName="mb-2"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}


            <RoleSelectionModal
                isOpen={showRoleSelectionModal}
                onClose={handleCloseRoleModal}
                canEdit={true}
                onSelected={(role: Role) => {
                    setRole(role);
                    setDisplayRoleName(role?.display_role_name ?? '')
                }}
            />

        </React.Fragment>
    )

}

export default AddEmployeeContact;